import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.65 8.25a8.25 8.25 0 1 1-.042 7.416.75.75 0 1 0-1.344.668A9.75 9.75 0 0 0 12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25a9.74 9.74 0 0 0-8.25 4.552V3.004a.75.75 0 0 0-1.5 0V9c0 .414.336.75.75.75h6a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ])))
}
export default { render: render }